"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _BillDetailDrawer = _interopRequireDefault(require("./components/BillDetailDrawer"));
var _merchantElectricity = require("@/api/merchantElectricity");
var _constants = require("./constants");
var _utils = require("./utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantElectricityMonthlyBill',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default,
    BillDetailDrawer: _BillDetailDrawer.default
  },
  data: function data() {
    return {
      listLoading: false,
      exportLoading: false,
      building: false,
      buildBillMonth: (0, _utils.defaultLastMonth)(),
      list: [],
      tableMaxH: 400,
      listQuery: {
        start: 1,
        limit: 20,
        page_num: 0,
        total: 0
      },
      filter: {
        bill_month: '',
        status: '',
        merchant_name: ''
      },
      statusOptions: _constants.BILL_STATUS_OPTIONS
    };
  },
  computed: {
    canBuildBill: function canBuildBill() {
      return this.checkRoles(['terminal', 'partner']);
    }
  },
  mounted: function mounted() {
    if (this.$route.query.status !== undefined && this.$route.query.status !== '') {
      this.filter.status = parseInt(this.$route.query.status, 10);
    }
    this.getList();
  },
  methods: {
    formatMoney: _utils.formatMoney,
    formatKwh: _utils.formatKwh,
    formatAccount: _utils.formatAccount,
    billStatusType: function billStatusType(status) {
      var m = _constants.BILL_STATUS[status];
      return m ? m.type : 'info';
    },
    toQuery: function toQuery() {
      this.$refs.filterDrawer && this.$refs.filterDrawer.hide();
      this.listQuery.start = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.filter = {
        bill_month: '',
        status: '',
        merchant_name: ''
      };
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        start: this.listQuery.start - 1,
        limit: this.listQuery.limit,
        summary_only: 1
      };
      if (this.filter.bill_month) params.bill_month = this.filter.bill_month;
      if (this.filter.status !== '' && this.filter.status !== null && this.filter.status !== undefined) {
        params.status = this.filter.status;
      }
      if (this.filter.merchant_name) params.merchant_name = this.filter.merchant_name;
      (0, _merchantElectricity.getMonthlyBillList)(params).then(function (res) {
        _this.list = res && res.list || [];
        var total = res && res.total != null ? res.total : 0;
        _this.listQuery.total = total;
        _this.listQuery.page_num = Math.ceil(total / _this.listQuery.limit) || 0;
        if (params.start === 0 && _this.$refs.list_table) {
          _this.$nextTick(function () {
            _this.tableMaxH = window.innerHeight - _this.$refs.list_table.$el.offsetTop - 80;
          });
        }
      }).catch(function (err) {
        _this.$message.error(err && err.msg || '加载失败');
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    openDetail: function openDetail(row) {
      this.$refs.billDetail.open(row.id);
    },
    quickConfirm: function quickConfirm(row) {
      var _this2 = this;
      this.$confirm('确认该月度账单？', '确认账单', {
        type: 'warning'
      }).then(function () {
        return (0, _merchantElectricity.confirmBill)(row.id);
      }).then(function () {
        _this2.$message.success('已确认');
        _this2.getList();
      }).catch(function () {});
    },
    quickSettle: function quickSettle(row) {
      var _this3 = this;
      var payer = (0, _utils.formatAccount)(row.agent_aid, row.payer_name);
      var payee = (0, _utils.formatAccount)(row.merchant_aid, row.payee_name || row.merchant_name);
      var amount = (0, _utils.formatMoney)(row.total_amount);
      var tip = "\u5C06\u4ECE\u3010".concat(payer, "\u3011\u94B1\u5305\u5212\u81F3\u3010").concat(payee, "\u3011\u94B1\u5305\uFF0C\u91D1\u989D ").concat(amount, "\u3002\u4F59\u989D\u4E0D\u8DB3\u4F1A\u5931\u8D25\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F");
      this.$confirm(tip, '打款结算', {
        type: 'warning'
      }).then(function () {
        return (0, _merchantElectricity.settleBill)(row.id);
      }).then(function () {
        _this3.$message.success('打款成功');
        _this3.getList();
      }).catch(function (err) {
        if (err && err.msg) _this3.$message.error(err.msg);
      });
    },
    onBuildBillMonthChange: function onBuildBillMonthChange(val) {
      this.buildBillMonth = (0, _utils.formatBillMonth)(val);
    },
    resolveBuildBillMonth: function resolveBuildBillMonth() {
      var picker = this.$refs.buildBillMonthPicker;
      if (picker && picker.parsedValue instanceof Date && !isNaN(picker.parsedValue.getTime())) {
        return (0, _utils.formatBillMonth)(picker.parsedValue);
      }
      if (picker && picker.displayValue) {
        return (0, _utils.formatBillMonth)(picker.displayValue);
      }
      return (0, _utils.formatBillMonth)(this.buildBillMonth);
    },
    handleBuildBill: function handleBuildBill() {
      var _this4 = this;
      var picker = this.$refs.buildBillMonthPicker;
      if (picker && typeof picker.handleClose === 'function') {
        picker.handleClose();
      }
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      this.$nextTick(function () {
        var month = _this4.resolveBuildBillMonth();
        if (!month) {
          _this4.$message.warning('请选择要生成的账单月份');
          return;
        }
        _this4.buildBillMonth = month;
        _this4.$confirm("\u751F\u6210 ".concat(month, " \u6708\u5EA6\u8D26\u5355\uFF1F"), '生成账单', {
          type: 'warning'
        }).then(function () {
          _this4.building = true;
          return (0, _merchantElectricity.buildMonthlyBill)(month);
        }).then(function () {
          _this4.$message.success('已提交生成');
          _this4.filter.bill_month = month;
          _this4.listQuery.start = 1;
          _this4.getList();
        }).catch(function (err) {
          if (err && err.msg) _this4.$message.error(err.msg);
        }).finally(function () {
          _this4.building = false;
        });
      });
    },
    buildBillExportParams: function buildBillExportParams() {
      var params = {
        summary_only: 1
      };
      if (this.filter.bill_month) params.bill_month = this.filter.bill_month;
      if (this.filter.status !== '' && this.filter.status !== null && this.filter.status !== undefined) {
        params.status = this.filter.status;
      }
      if (this.filter.merchant_name) params.merchant_name = this.filter.merchant_name;
      return params;
    },
    handleExportBills: function handleExportBills() {
      var _this5 = this;
      this.exportLoading = true;
      (0, _merchantElectricity.exportMonthlyBill)(this.buildBillExportParams()).catch(function () {}).finally(function () {
        _this5.exportLoading = false;
      });
    }
  }
};